module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_skins.b9980e24.png";